import { useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { IconUpload } from '@iwoca/icons';
import { Button } from '@iwoca/orion';

import { useStateKey } from '../../../../hooks/useStateKey.hook';
import { downloadAsAttachment } from '../../../../Pages/lendingApiFetch';

export const ExportCSV = ({
  fetcher,
  setIsLoading,
}: {
  fetcher: ({ stateKey }: { stateKey: string }) => Promise<Response>;
  setIsLoading: (loading: boolean) => void;
}) => {
  const { stateKey } = useStateKey();
  const [errorCustomersDownload, setErrorCustomersDownload] = useState(false);

  const handleDownload = async () => {
    tracking.ampli.customersPageExportButtonClicked();
    setErrorCustomersDownload(false);
    setIsLoading(true);

    try {
      const response = await fetcher({
        stateKey: stateKey!,
      });
      await downloadAsAttachment(response);
    } catch (error) {
      if (error instanceof Error && error?.name === 'AbortError') {
        // Don't show an error message if the user aborted the request
        return;
      }
      setErrorCustomersDownload(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-end gap-xs">
      <Button
        variant="tertiary"
        className="!text-s font-bold text-primary-40"
        onClick={handleDownload}
      >
        <div className="flex gap-s">
          <div>Export...</div>
          <IconUpload />
        </div>
      </Button>
      {errorCustomersDownload && (
        <div className="text-xs text-error">Something went wrong</div>
      )}
    </div>
  );
};
